import React from 'react';
import Box from '@mui/joy/Box';
import CircularProgress from '@mui/joy/CircularProgress';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';

export default function LoadingState({
  message = 'Loading...',
  size = 'lg',
  centered = true
}) {
  const content = (
    <Stack spacing={2} alignItems="center">
      <CircularProgress size={size} />
      {message && (
        <Typography level="body-md" sx={{ color: 'text.secondary' }}>
          {message}
        </Typography>
      )}
    </Stack>
  );

  if (centered) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 200,
          width: '100%'
        }}
      >
        {content}
      </Box>
    );
  }

  return content;
}